/**
 *
 * @param {import("../types/session").Session} session
 * @param {*} requestAttributes
 * @returns {*}
 *
 * Always sets human_mode false. Later if there's a way for the user to start a
 * human conversation directly then this needs an equivalent for callOpenHuman
 * or something like that. Note that we don't do any handling with the response
 * from this route, so it's not async. Just call it once and move on.
 */
export async function callCloseHuman(session, requestAttributes) {
  const url = process.env.BASEURL + "/human/close";

  fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-MagicForm-Version": GITHASH,
      "X-MagicForm-Route": "v2",
    },
    body: JSON.stringify({
      payload: {
        session: { ...session, human_mode: false },
        user_id: requestAttributes.user_id,
        stack_id: requestAttributes.stack_id,
        channel: {
          env: "PROD",
          hostname: requestAttributes.hostname,
        },
        lang_override: requestAttributes.lang_override,
        chat_context: requestAttributes.chat_context,
        lead_context: requestAttributes.lead_context,
      },
    }),
  }).catch((error) => {
    console.error("error closing human human chat", error);
  });
}
